import React, { Component } from "react";
import { RouteChildrenProps } from "react-router";
import { ISocialFeedState, SocialPostContainer } from "src/social-feed";
import api from "src/spintr/SpintrApi";
import SpintrLoader from "src/ui/components/Loader";
import "../SocialFeedContainer/SocialFeedContainer.scss";
import "./SocialPostView.scss";
import { MapStateToProps, connect } from "react-redux";
import { SpintrTypes } from "src/typings";

type RouteParams = {
    statusId: string;
}

type OwnProps = {};
type StateProps = {
    socialFeed: ISocialFeedState
    productsOptions: {
        enabled: boolean;
        canAddProducts: boolean;
        patterns: RegExp[];
    };
}

type Props = OwnProps & StateProps & RouteChildrenProps<RouteParams>;

interface IState {
    isLoading: boolean;
    hasReduxPost: boolean;
    post?: Spintr.ISocialImage; //FIXME ISocialPostBase
}

class SocialPostView extends Component<Props, IState> {
    protected fetchTimeout?: ReturnType<typeof setTimeout>;

    constructor(props: Props) {
        super(props);

        const item = this.getPostFromRedux();

        this.state = {
            isLoading: !item,
            hasReduxPost: !!item
        };
    }

    getPostFromRedux() {
        const id = parseInt(this.props.match.params.statusId);

        for (const [key, value] of Object.entries(this.props.socialFeed)) {
            if (value.entries) {
                const item = value.entries.find(x => x.Id === id);

                if (item) {
                    return item;
                }
            }
        }

        return null;
    }

    fetch = async () => {
        if (this.state.hasReduxPost) {
            return;
        }

        const id = this.props.match.params.statusId;
        await api
            .get(`/api/v1/status/${id}`)
            .then(async (response) => {
                if (this.videoIsUploading(response.data)) {
                    this.fetchTimeout = setTimeout(this.fetch, 5000);
                }

                this.setState({ post: response.data, isLoading: false });
            })
            .catch((err) => {
                this.props.history.push("/404");
            });
    };

    componentDidUpdate = (prevProps) => {
        if (
            this.props.match.params["statusId"] !== prevProps.match.params["statusId"] &&
            this.props.match.params["statusId"]
        ) {
            this.fetch();
        }
    };

    videoIsUploading = (post) => {
        const isImage: boolean =
            post.photos !== undefined && post.photos.length > 0 && !post.photos[0].videoThumbnailUrl;

        return !isImage && post.FileStatus >= 0 && post.FileStatus <= 2;
    };

    componentDidMount = async () => {
        await this.fetch();
    };

    componentWillUnmount() {
        if (this.fetchTimeout) {
            clearTimeout(this.fetchTimeout);
        }
    }

    protected getPostKey(item: Spintr.ISocialPostBase): string {
        return "SFC.Post." + item.Id + "." + (item.isFavourited ? "1" : "0") + "." + (item.isFollowing ? "1" : "0");
    }

    render() {
        if (this.state.isLoading) return <SpintrLoader />;

        const post = this.state.hasReduxPost ?
            this.getPostFromRedux() :
            this.state.post;

        return (
            <div className="SocialPostView page-margin-bottom">
                <div className="socialFeed">
                    <div className="SpintrSocialFeed">
                        <div className="social-post-feed">
                            <SocialPostContainer
                                key={this.getPostKey(post)}
                                post={post}
                                onDoneEditing={() => {
                                    this.fetch();
                                }}
                                interactiveTextOptions={{
                                    products: {
                                        enabled: this.props.productsOptions?.enabled || false,
                                        canAddProducts: this.props.productsOptions?.canAddProducts || false,
                                        patterns: this.props.productsOptions?.patterns || [],
                                    }
                                }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps: MapStateToProps<StateProps, OwnProps, Spintr.AppState> = (state) => {
    const elevatedPrivileges = state.profile.active.roles.some(
        (role) => role === "administrators" || role === "editor",
    );

    return {
        socialFeed: state.socialFeed,
        productsOptions: {
            enabled: (state.instance.apps || state.instance.get("apps") || [])
                .some((app: any) => app.id === SpintrTypes.SpintrApp.Products && app.enabled === true),
            canAddProducts: elevatedPrivileges,
            patterns: !elevatedPrivileges
                ? []
                : (state.instance.get("articleIdPatterns") || [])
                    .map((pattern: string) => {
                        try {
                            return new RegExp(pattern, "gmi");
                        } catch (_) {
                            return null;
                        }
                    })
                    .filter((pattern: RegExp | null) => pattern !== null),
        }
    }
};

export default connect(mapStateToProps)(SocialPostView);